function odmiana (liczba, pojedyncza, mnoga, mnogaDopelniacz) {
  liczba = Math.abs(liczba) // tylko jeśli mogą zdarzyć się liczby ujemne
  if (liczba === 1) return pojedyncza
  var reszta10 = liczba % 10
  var reszta100 = liczba % 100
  if (reszta10 > 4 || reszta10 < 2 || (reszta100 < 15 && reszta100 > 11)) { return mnogaDopelniacz }
  return mnoga
}

export default odmiana



// WEBPACK FOOTER //
// ./src/shared/polishends.js